import React from "react"

// styles
import "./CollapsePabelButton.scss"

const CollapsePanelButton = ({ placement = "left", open, setOpen = () => {}, className = "", style = {} }) => {
  const containerClassNames = ["collapse-panel-button-container", className]
  if (open === false) containerClassNames.push("collapse-panel-button-closed")

  return (
    <div
      style={style}
      className={containerClassNames.join(" ")}
      onClick={setOpen}
      data-tour={open ? null : "collapse-panel-button-closed"}
    >
      <i
        className={`collapse-btn-icon fa-solid fa-caret-${open ? placement : placement === "left" ? "right" : "left"}`}
      />
    </div>
  )
}

export default CollapsePanelButton
